if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class extends HTMLElement {
      connectedCallback() {
        const priceEl = document.getElementById(this.dataset.target);
        const out = this.querySelector('[data-sp-sticky-price]');

        if (priceEl && out) {
          const sync = () => {
            const node = priceEl.querySelector(
              '.price-item--sale, .price-item--regular, .price-item'
            );
            if (node) out.textContent = node.textContent.trim();
          };
          sync();
          new MutationObserver(sync).observe(priceEl, {
            subtree: true,
            childList: true,
            characterData: true,
          });
        }

        const anchor = priceEl;
        if (anchor && 'IntersectionObserver' in window) {
          new IntersectionObserver(
            (entries) => {
              const e = entries[0];
              this.classList.toggle(
                'is-visible',
                !e.isIntersecting && e.boundingClientRect.top < 0
              );
            },
            { threshold: 0 }
          ).observe(anchor);
        } else {
          this.classList.add('is-visible');
        }
      }
    }
  );
}
